import { IconDocument1 } from 'assets/img';
import { ContextMenuItem } from 'redesign';
import { shiftAlerts, useAlert } from 'shared/components/alerts';
import { ShiftClaimant } from 'shared/components/shift-detail-modal/components/tabs/claimants/claimant-table.types';
import { useGetShiftClaimContract } from '../query-hooks/use-get-shift-claim-contract';

export const HQDownloadContractAction = ({ candidate }: { candidate: ShiftClaimant }) => {
  const { alertSuccess, alertError } = useAlert();
  const getContract = useGetShiftClaimContract({
    onSuccess: () => alertSuccess(shiftAlerts.success.downloadOvo),
    onError: (e) => alertError(e),
  });

  return (
    <ContextMenuItem
      onClick={() => getContract.mutate(candidate.claimId)}
      key={`ovo-${candidate.claimId}`}
    >
      <IconDocument1 />
      Overeenkomst
    </ContextMenuItem>
  );
};
